// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AdminSecurityPage_ManagedSftpPublicKeyFragment = { __typename?: 'ManagedSFTPPublicKey', id: string, fingerprintSHA256: string, algorithm: string, status: Types.ManagedSftpPublicKeyStatus, createdAt: Time };

export type AdminSecurityPage_ManagedSftpConnectionFragment = { __typename?: 'ManagedSFTPConnection', id: string, username: string, status: Types.ManagedSftpConnectionStatus, createdAt: Time, instructions: { __typename?: 'ManagedSFTPConnectionInstructions', hostname: string, port: number, remoteRoot: string, hostKeyFingerprints: Array<{ __typename?: 'ManagedSFTPHostKeyFingerprint', fingerprint: string }> }, publicKeys: Array<(
    { __typename?: 'ManagedSFTPPublicKey' }
    & AdminSecurityPage_ManagedSftpPublicKeyFragment
  )> };

export type AdminSecurityPageManagedSftpQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AdminSecurityPageManagedSftpQuery = { __typename?: 'Query', managedSFTP?: (
    { __typename?: 'ManagedSFTPConnection' }
    & AdminSecurityPage_ManagedSftpConnectionFragment
  ) | null };

export type AdminSecurityPageEnableManagedSftpMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type AdminSecurityPageEnableManagedSftpMutation = { __typename?: 'Mutation', enableManagedSFTP: { __typename?: 'ManagedSFTPConnection', id: string } };

export type AdminSecurityPageAddManagedSftpPublicKeyMutationVariables = Types.Exact<{
  input: Types.AddManagedSftpPublicKeyInput;
}>;


export type AdminSecurityPageAddManagedSftpPublicKeyMutation = { __typename?: 'Mutation', addManagedSFTPPublicKey: { __typename?: 'ManagedSFTPPublicKey', id: string } };

export type AdminSecurityPageRevokeManagedSftpPublicKeyMutationVariables = Types.Exact<{
  input: Types.RevokeManagedSftpPublicKeyInput;
}>;


export type AdminSecurityPageRevokeManagedSftpPublicKeyMutation = { __typename?: 'Mutation', revokeManagedSFTPPublicKey: boolean };

export type AdminSecurityPageDisableManagedSftpMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type AdminSecurityPageDisableManagedSftpMutation = { __typename?: 'Mutation', disableManagedSFTP: { __typename?: 'ManagedSFTPConnection', id: string } };

export const Operations = {
  Query: {
    AdminSecurityPageManagedSFTP: 'AdminSecurityPageManagedSFTP' as const
  },
  Mutation: {
    AdminSecurityPageEnableManagedSFTP: 'AdminSecurityPageEnableManagedSFTP' as const,
    AdminSecurityPageAddManagedSFTPPublicKey: 'AdminSecurityPageAddManagedSFTPPublicKey' as const,
    AdminSecurityPageRevokeManagedSFTPPublicKey: 'AdminSecurityPageRevokeManagedSFTPPublicKey' as const,
    AdminSecurityPageDisableManagedSFTP: 'AdminSecurityPageDisableManagedSFTP' as const
  },
  Fragment: {
    AdminSecurityPage_ManagedSFTPPublicKey: 'AdminSecurityPage_ManagedSFTPPublicKey' as const,
    AdminSecurityPage_ManagedSFTPConnection: 'AdminSecurityPage_ManagedSFTPConnection' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const AdminSecurityPage_ManagedSftpPublicKeyFragmentDoc = gql`
    fragment AdminSecurityPage_ManagedSFTPPublicKey on ManagedSFTPPublicKey {
  id
  fingerprintSHA256
  algorithm
  status
  createdAt
}
    `;
export const AdminSecurityPage_ManagedSftpConnectionFragmentDoc = gql`
    fragment AdminSecurityPage_ManagedSFTPConnection on ManagedSFTPConnection {
  id
  username
  instructions {
    hostname
    port
    remoteRoot
    hostKeyFingerprints {
      fingerprint
    }
  }
  status
  createdAt
  publicKeys {
    ...AdminSecurityPage_ManagedSFTPPublicKey
  }
}
    ${AdminSecurityPage_ManagedSftpPublicKeyFragmentDoc}`;
export const AdminSecurityPageManagedSftpDocument = gql`
    query AdminSecurityPageManagedSFTP {
  managedSFTP {
    ...AdminSecurityPage_ManagedSFTPConnection
  }
}
    ${AdminSecurityPage_ManagedSftpConnectionFragmentDoc}`;

/**
 * __useAdminSecurityPageManagedSftpQuery__
 *
 * To run a query within a React component, call `useAdminSecurityPageManagedSftpQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminSecurityPageManagedSftpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminSecurityPageManagedSftpQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminSecurityPageManagedSftpQuery(baseOptions?: Apollo.QueryHookOptions<AdminSecurityPageManagedSftpQuery, AdminSecurityPageManagedSftpQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminSecurityPageManagedSftpQuery, AdminSecurityPageManagedSftpQueryVariables>(AdminSecurityPageManagedSftpDocument, withFetchPolicyContext(options));
      }
export function useAdminSecurityPageManagedSftpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminSecurityPageManagedSftpQuery, AdminSecurityPageManagedSftpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminSecurityPageManagedSftpQuery, AdminSecurityPageManagedSftpQueryVariables>(AdminSecurityPageManagedSftpDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useAdminSecurityPageManagedSftpSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminSecurityPageManagedSftpQuery, AdminSecurityPageManagedSftpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminSecurityPageManagedSftpQuery, AdminSecurityPageManagedSftpQueryVariables>(AdminSecurityPageManagedSftpDocument, withFetchPolicyContext(options));
        }
export type AdminSecurityPageManagedSftpQueryHookResult = ReturnType<typeof useAdminSecurityPageManagedSftpQuery>;
export type AdminSecurityPageManagedSftpLazyQueryHookResult = ReturnType<typeof useAdminSecurityPageManagedSftpLazyQuery>;
export type AdminSecurityPageManagedSftpSuspenseQueryHookResult = ReturnType<typeof useAdminSecurityPageManagedSftpSuspenseQuery>;
export type AdminSecurityPageManagedSftpQueryResult = Apollo.QueryResult<AdminSecurityPageManagedSftpQuery, AdminSecurityPageManagedSftpQueryVariables>;
export const AdminSecurityPageEnableManagedSftpDocument = gql`
    mutation AdminSecurityPageEnableManagedSFTP {
  enableManagedSFTP {
    id
  }
}
    `;
export type AdminSecurityPageEnableManagedSftpMutationFn = Apollo.MutationFunction<AdminSecurityPageEnableManagedSftpMutation, AdminSecurityPageEnableManagedSftpMutationVariables>;

/**
 * __useAdminSecurityPageEnableManagedSftpMutation__
 *
 * To run a mutation, you first call `useAdminSecurityPageEnableManagedSftpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSecurityPageEnableManagedSftpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSecurityPageEnableManagedSftpMutation, { data, loading, error }] = useAdminSecurityPageEnableManagedSftpMutation({
 *   variables: {
 *   },
 * });
 */
export function useAdminSecurityPageEnableManagedSftpMutation(baseOptions?: Apollo.MutationHookOptions<AdminSecurityPageEnableManagedSftpMutation, AdminSecurityPageEnableManagedSftpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminSecurityPageEnableManagedSftpMutation, AdminSecurityPageEnableManagedSftpMutationVariables>(AdminSecurityPageEnableManagedSftpDocument, options);
      }
export type AdminSecurityPageEnableManagedSftpMutationHookResult = ReturnType<typeof useAdminSecurityPageEnableManagedSftpMutation>;
export type AdminSecurityPageEnableManagedSftpMutationResult = Apollo.MutationResult<AdminSecurityPageEnableManagedSftpMutation>;
export type AdminSecurityPageEnableManagedSftpMutationOptions = Apollo.BaseMutationOptions<AdminSecurityPageEnableManagedSftpMutation, AdminSecurityPageEnableManagedSftpMutationVariables>;
export const AdminSecurityPageAddManagedSftpPublicKeyDocument = gql`
    mutation AdminSecurityPageAddManagedSFTPPublicKey($input: AddManagedSFTPPublicKeyInput!) {
  addManagedSFTPPublicKey(input: $input) {
    id
  }
}
    `;
export type AdminSecurityPageAddManagedSftpPublicKeyMutationFn = Apollo.MutationFunction<AdminSecurityPageAddManagedSftpPublicKeyMutation, AdminSecurityPageAddManagedSftpPublicKeyMutationVariables>;

/**
 * __useAdminSecurityPageAddManagedSftpPublicKeyMutation__
 *
 * To run a mutation, you first call `useAdminSecurityPageAddManagedSftpPublicKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSecurityPageAddManagedSftpPublicKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSecurityPageAddManagedSftpPublicKeyMutation, { data, loading, error }] = useAdminSecurityPageAddManagedSftpPublicKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminSecurityPageAddManagedSftpPublicKeyMutation(baseOptions?: Apollo.MutationHookOptions<AdminSecurityPageAddManagedSftpPublicKeyMutation, AdminSecurityPageAddManagedSftpPublicKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminSecurityPageAddManagedSftpPublicKeyMutation, AdminSecurityPageAddManagedSftpPublicKeyMutationVariables>(AdminSecurityPageAddManagedSftpPublicKeyDocument, options);
      }
export type AdminSecurityPageAddManagedSftpPublicKeyMutationHookResult = ReturnType<typeof useAdminSecurityPageAddManagedSftpPublicKeyMutation>;
export type AdminSecurityPageAddManagedSftpPublicKeyMutationResult = Apollo.MutationResult<AdminSecurityPageAddManagedSftpPublicKeyMutation>;
export type AdminSecurityPageAddManagedSftpPublicKeyMutationOptions = Apollo.BaseMutationOptions<AdminSecurityPageAddManagedSftpPublicKeyMutation, AdminSecurityPageAddManagedSftpPublicKeyMutationVariables>;
export const AdminSecurityPageRevokeManagedSftpPublicKeyDocument = gql`
    mutation AdminSecurityPageRevokeManagedSFTPPublicKey($input: RevokeManagedSFTPPublicKeyInput!) {
  revokeManagedSFTPPublicKey(input: $input)
}
    `;
export type AdminSecurityPageRevokeManagedSftpPublicKeyMutationFn = Apollo.MutationFunction<AdminSecurityPageRevokeManagedSftpPublicKeyMutation, AdminSecurityPageRevokeManagedSftpPublicKeyMutationVariables>;

/**
 * __useAdminSecurityPageRevokeManagedSftpPublicKeyMutation__
 *
 * To run a mutation, you first call `useAdminSecurityPageRevokeManagedSftpPublicKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSecurityPageRevokeManagedSftpPublicKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSecurityPageRevokeManagedSftpPublicKeyMutation, { data, loading, error }] = useAdminSecurityPageRevokeManagedSftpPublicKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminSecurityPageRevokeManagedSftpPublicKeyMutation(baseOptions?: Apollo.MutationHookOptions<AdminSecurityPageRevokeManagedSftpPublicKeyMutation, AdminSecurityPageRevokeManagedSftpPublicKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminSecurityPageRevokeManagedSftpPublicKeyMutation, AdminSecurityPageRevokeManagedSftpPublicKeyMutationVariables>(AdminSecurityPageRevokeManagedSftpPublicKeyDocument, options);
      }
export type AdminSecurityPageRevokeManagedSftpPublicKeyMutationHookResult = ReturnType<typeof useAdminSecurityPageRevokeManagedSftpPublicKeyMutation>;
export type AdminSecurityPageRevokeManagedSftpPublicKeyMutationResult = Apollo.MutationResult<AdminSecurityPageRevokeManagedSftpPublicKeyMutation>;
export type AdminSecurityPageRevokeManagedSftpPublicKeyMutationOptions = Apollo.BaseMutationOptions<AdminSecurityPageRevokeManagedSftpPublicKeyMutation, AdminSecurityPageRevokeManagedSftpPublicKeyMutationVariables>;
export const AdminSecurityPageDisableManagedSftpDocument = gql`
    mutation AdminSecurityPageDisableManagedSFTP {
  disableManagedSFTP {
    id
  }
}
    `;
export type AdminSecurityPageDisableManagedSftpMutationFn = Apollo.MutationFunction<AdminSecurityPageDisableManagedSftpMutation, AdminSecurityPageDisableManagedSftpMutationVariables>;

/**
 * __useAdminSecurityPageDisableManagedSftpMutation__
 *
 * To run a mutation, you first call `useAdminSecurityPageDisableManagedSftpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSecurityPageDisableManagedSftpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSecurityPageDisableManagedSftpMutation, { data, loading, error }] = useAdminSecurityPageDisableManagedSftpMutation({
 *   variables: {
 *   },
 * });
 */
export function useAdminSecurityPageDisableManagedSftpMutation(baseOptions?: Apollo.MutationHookOptions<AdminSecurityPageDisableManagedSftpMutation, AdminSecurityPageDisableManagedSftpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminSecurityPageDisableManagedSftpMutation, AdminSecurityPageDisableManagedSftpMutationVariables>(AdminSecurityPageDisableManagedSftpDocument, options);
      }
export type AdminSecurityPageDisableManagedSftpMutationHookResult = ReturnType<typeof useAdminSecurityPageDisableManagedSftpMutation>;
export type AdminSecurityPageDisableManagedSftpMutationResult = Apollo.MutationResult<AdminSecurityPageDisableManagedSftpMutation>;
export type AdminSecurityPageDisableManagedSftpMutationOptions = Apollo.BaseMutationOptions<AdminSecurityPageDisableManagedSftpMutation, AdminSecurityPageDisableManagedSftpMutationVariables>;